<div>
  <app-state-section [state]="sectionState" [errorStateLabel]="'ErrorMessages.ErrorHappened' | translate">
    <ng-container content *ngIf="pickupLocation">
      <div class="flex align-center mb-6 pt-2">
        <div class="mr-4">
          <app-icon name="marker"></app-icon>
        </div>
        <div class="col">
          <p class="m-0 text-on-surface-light-emphasis">{{'AddShipment.PickupLocation' |translate}}</p>
          <h6 class="mb-0 weight-bold">{{pickupLocation.address}}</h6>
        </div>
      </div>
      <app-tab [tabs]="tabs" [selectedIndex]="selectedTabIndex" (currentIndex)="getCurrentTabIndex($event)" class="tabs--info">
        <ng-container [ngSwitch]="currentTabIndex">
          <ng-container *ngSwitchCase="0">
            <app-shipment-detection-tab
              [status]="'ONLINE'"
              (selectDriver)="handleSelectedDriver($event)"
              [pickupLocation]="pickupLocation"
              [customerId]="customerId"
            ></app-shipment-detection-tab>
          </ng-container>

          <ng-container *ngSwitchCase="1">
            <app-shipment-detection-tab
              [status]="'OFFLINE'"
              (selectDriver)="handleSelectedDriver($event)"
              [pickupLocation]="pickupLocation"
              [customerId]="customerId"
            ></app-shipment-detection-tab>
          </ng-container>
        </ng-container>
      </app-tab>
    </ng-container>

    <div class="flex buttons-container justify-space-between">
      <button mat-raised-button class="btn btn-secondary px-8" (click)="closeModal.emit()">{{'Buttons.Cancel' | translate}}</button>
      <button mat-raised-button class="btn-primary px-8" (click)="onClickSave()" [disabled]="!driver">{{'Buttons.Save' | translate}}</button>
    </div>
  </app-state-section>
</div>
